import { IconFigmaAlertTriangle, IconFigmaCheckCircle, IconFigmaXCircle } from '@/assets/icons';

export const errorNotificationIcon = <IconFigmaXCircle size={16} />;
export const warningNotificationIcon = <IconFigmaAlertTriangle size={16} />;
export const successNotificationIcon = <IconFigmaCheckCircle size={16} />;
